export default {"src":"/_next/static/media/peep-att.ee089140.svg","height":1500,"width":1500};